/**
 * API fields like `message` / `detail` may be a plain string, an array of strings,
 * FastAPI validation objects, or a nested `{ message: "..." }`.
 * Returns a non-empty string or null.
 */
export function formatApiMessage(value, depth = 0) {
  if (value == null || depth > 8) return null;

  if (typeof value === "string") {
    const t = value.trim();
    return t !== "" ? t : null;
  }

  if (Array.isArray(value)) {
    const parts = value
      .map((item) => formatApiMessage(item, depth + 1))
      .filter(Boolean);
    return parts.length > 0 ? parts.join(" ") : null;
  }

  if (typeof value === "object") {
    if (Object.prototype.hasOwnProperty.call(value, "message")) {
      const inner = formatApiMessage(value.message, depth + 1);
      if (inner) return inner;
    }
    // FastAPI validation error item: { loc, msg, type }
    if (typeof value.msg === "string") {
      const t = value.msg.trim();
      if (t !== "") return t;
    }
    if (typeof value.error === "string") {
      const t = value.error.trim();
      if (t !== "") return t;
    }
    if (Object.prototype.hasOwnProperty.call(value, "detail")) {
      const inner = formatApiMessage(value.detail, depth + 1);
      if (inner) return inner;
    }
    return null;
  }

  const s = String(value).trim();
  return s !== "" ? s : null;
}
